var exports = {
  "Lw": "VoiceRegionTeleportOverlay.module__overlay___dFFRQ0",
  "t5": "VoiceRegionTeleportOverlay.module__voiceRegionTeleportFadeIn___dFFRQ0",
  "Vs": "VoiceRegionTeleportOverlay.module__tile___dFFRQ0",
  "Pf": "VoiceRegionTeleportOverlay.module__label___dFFRQ0",
};

module.exports = exports;
